/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiImage,
    ApiImageFromJSON,
    ApiImageFromJSONTyped,
    ApiImageToJSON,
} from './';

/**
 * 
 * @export
 * @interface ApiCountryEyecatcher
 */
export interface ApiCountryEyecatcher {
    /**
     * 
     * @type {ApiImage}
     * @memberof ApiCountryEyecatcher
     */
    image?: ApiImage;
    /**
     * 
     * @type {string}
     * @memberof ApiCountryEyecatcher
     */
    position?: string;
}

export function ApiCountryEyecatcherFromJSON(json: any): ApiCountryEyecatcher {
    return ApiCountryEyecatcherFromJSONTyped(json, false);
}

export function ApiCountryEyecatcherFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCountryEyecatcher {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'image': !exists(json, 'image') ? undefined : ApiImageFromJSON(json['image']),
        'position': !exists(json, 'position') ? undefined : json['position'],
    };
}

export function ApiCountryEyecatcherToJSON(value?: ApiCountryEyecatcher | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image': ApiImageToJSON(value.image),
        'position': value.position,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
